import React, { useMemo } from 'react'

import { PackageConfigurationInterface } from '@store/types'

import { LotInterface } from '@api/houseAndLand'

import ShortlistAction from './shortlist-action'

interface LotCardHeaderProps {
  lot: LotInterface
  totalPackage: number
  stageId: string
  precinctId: string
  packageConfiguration: PackageConfigurationInterface
  isShortlisted: boolean
  availableStatusLabel: string
  statusColor: string
}

function LotCardHeader({
  lot,
  totalPackage,
  stageId,
  precinctId,
  packageConfiguration,
  isShortlisted,
  availableStatusLabel,
  statusColor,
}: LotCardHeaderProps) {
  const showPackageCountLabel = useMemo<boolean>(() => {
    if (lot.status !== availableStatusLabel) {
      return false
    }
    if (!lot.lotOnlyReservation && totalPackage > 0) {
      return true
    }
    return false
  }, [lot.lotOnlyReservation, totalPackage, lot.status, availableStatusLabel])

  const packageCountLabel = useMemo<string | undefined>(() => {
    if (totalPackage === 1) {
      return `${totalPackage} Package`
    }
    if (totalPackage > 1) {
      return `${totalPackage} Packages`
    }
    return undefined
  }, [totalPackage])

  return (
    <div className="mb-2 flex justify-between gap-1">
      <div className="flex min-w-0 items-center">
        <div className="flex-1 truncate">
          <span className="text-[18px] font-bold leading-[21.5px]">
            Lot {lot.name}
          </span>
        </div>
        <span
          className="-mt-[2px] ml-4 h-2 w-2 rounded-full"
          style={{
            backgroundColor: statusColor,
          }}
        ></span>
        <span
          className="ml-1 text-xs font-semibold uppercase leading-[14px] tracking-widest"
          style={{
            color: statusColor,
          }}
        >
          {showPackageCountLabel && packageCountLabel
            ? packageCountLabel
            : lot.status}
        </span>
      </div>
      <ShortlistAction
        actionType="icon"
        lot={lot}
        stageId={stageId}
        precinctId={precinctId}
        packageConfiguration={isShortlisted ? undefined : packageConfiguration}
        isShortlisted={isShortlisted}
        availableStatusLabel={availableStatusLabel}
      />
    </div>
  )
}

export default LotCardHeader
